module.exports = __webpack_public_path__ + "img/information.73626e9f.svg";